import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/bank_card1.png'
import _imports_1 from '@/assets/image/vipImg/bank_card2.png'
import _imports_2 from '@/assets/image/vipImg/bank_card3.png'
import _imports_3 from '@/assets/image/vipImg/bank_card4.png'
import _imports_4 from '@/assets/image/vipImg/bank_card5.png'
import _imports_5 from '@/assets/image/vipImg/bank_card6.png'
import _imports_6 from '@/assets/image/vipImg/bank_card7.png'


const _withScopeId = n => (_pushScopeId("data-v-5608be06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "credit-card-pay-bank" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-card-pay-bank-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "credit-card-pay-tool-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "recharge-tips"
}
const _hoisted_6 = { class: "card-list" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-item-add" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-shangchuan" })
], -1))
const _hoisted_8 = { class: "card-item-add-text" }
const _hoisted_9 = {
  key: 0,
  class: "card-item-add-tip"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-tishi1" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "card-number" }
const _hoisted_13 = { class: "time" }
const _hoisted_14 = { class: "card-check" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "iconfont icon-xuanzhong1"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-gouxuan2" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "card-input rel"
}
const _hoisted_20 = { class: "card-input-text" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1))
const _hoisted_22 = { class: "card-input-div rel" }
const _hoisted_23 = {
  class: "abs",
  style: {"left":"0px","bottom":"-20px","color":"#333333"}
}
const _hoisted_24 = {
  key: 0,
  class: "el-form-item__error abs",
  style: {"left":"141px","top":"97px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-tishi1",
  style: {"margin-right":"6px","font-size":"14px"}
}, null, -1))
const _hoisted_26 = { class: "cart-card-list" }
const _hoisted_27 = { class: "cart-card-list-content" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "card-number" }
const _hoisted_30 = { class: "time" }
const _hoisted_31 = { class: "card-check" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 1,
  class: "check"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  src: "https://static-s.theckb.com/BusinessMarket/Client/choice/check_icon.png",
  alt: "",
  class: "check-img"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-item-add" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/choice/add_icon.png",
    alt: ""
  })
], -1))
const _hoisted_37 = { class: "card-item-add-text" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-template" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/choice/template_img.png",
    alt: ""
  })
], -1))
const _hoisted_39 = { class: "pay-btn-content" }
const _hoisted_40 = { class: "pay-btn-container" }
const _hoisted_41 = { class: "pay-left" }
const _hoisted_42 = { class: "pay-text" }
const _hoisted_43 = { class: "price" }
const _hoisted_44 = { class: "jpy" }
const _hoisted_45 = { class: "cny" }
const _hoisted_46 = {
  class: "cny",
  style: {"margin-top":"6px"}
}
const _hoisted_47 = { class: "pay-right" }

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import { getBankCardListApi, walletPaypalCaptureApi, authorizeApi, changeCreditCardDefaultStatusApi, deleteCreditCardApi, membershipPaypalCaptureApi, createVipPaypalCreditCardApi, createPaypalWalletApi, walletPaypalCardCaptureApi, membershipOrderCreateCreditFree } from '@/apis/pay'
import { useStore } from 'vuex'
import CreditCardPayDrawer from './CreditCardPayDrawer.vue'
import CreditCardPayDialog from './CreditCardPayDialog.vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import { Plus } from '@element-plus/icons-vue'
import PaypalPayModal from './components/PaypalPayModal.vue'
import PaypalTimeout from './components/PaypalTimeout.vue'
import { rate, floatingRate, floatingRateKrw, allIncludeExchangeRate } from '@/util/useYan'
import { useRoute } from 'vue-router'
import { isMultiStore } from '@/store'
import { formatMoney } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default: ''
  },
  membershipParams: {
    type: Object,
    default: () => { return {} }
  },
  isShopcart: {
    type: Boolean,
    default: false
  },
  remainingPrice: {
    type: Object,
    default: () => {
      return {
        cny: 0,
        jpy: 0,
        shopWallet: 0,
        shopWalletJPY: 0
      }
    }
  }
},
  emits: ['close', 'download', 'success'],
  setup(__props, { expose, emit }) {

const props = __props

const paypalAmount = computed(() => {
  return props.isShopcart ? Math.ceil(Math.ceil(props.remainingPrice?.cny * allIncludeExchangeRate.value) / (1 - 0.034)) : 0
})

const serveFee = computed(() => {
  if (props.isShopcart) {
    // 真实充值金额
    const a = Math.ceil(Math.ceil(props.remainingPrice?.cny * allIncludeExchangeRate.value) / (1 - 0.034))
    const b = a - props.remainingPrice.jpy
    return b
  }
  return 0
})
const store = useStore()

const creditCardPayVisible = ref(false)
const paypalTimeoutVisible = ref(false)
const cardList: any = ref([])
const activeCard: any = ref({})
const payPrice = ref('')
const paypalModalStatus = ref('') // paypal支付弹窗状态

const route = useRoute()

// 币种
const currencyCode = computed(() => {
  const { currencyCode = 'CNY' } = route.query
  // 如果没开通多仓，直接展示人民币
  if (!isMultiStore()) return 'CNY'
  return currencyCode
})

// 判断路由上币种为韩元且要要是日本站点
const isCurrencyCodeKRW = computed(() => {
  return currencyCode.value === 'KRW' && isMultiStore()
})

const getCardList = () => {
  getBankCardListApi({}).then((res: any) => {
    res.data.paymentTokens && res.data.paymentTokens.forEach((item: any) => {
      item.active = item.isDefault === 1
    })
    cardList.value = res.data.paymentTokens || []
    // activeCard.value = cardList.value.filter((item: any) => { return item.isDefault === 1 })[0]
  })
}
const isNoPrice = ref(false)
const inputPrice: any = (row: any) => {
  if (!payPrice.value) return
  payPrice.value = (payPrice.value.toString().match(/^[1-9]\d{0,8}/g) && payPrice.value.toString().match(/^[1-9]\d{0,8}/g)[0]) || ''
  isNoPrice.value = false
}
const submitLoading = ref(false)
const isNoCard = ref(false)
// 0 元付款
const isZeroPay = computed(() => props.membershipParams?.membershipTemplatePrice?.trialDiscount === -2)
// 存卡支付
const submit = (fn?: any) => {
  console.log('存卡支付')
  if (submitLoading.value) return
  // 卡列表长度为 0 报错
  if (cardList.value.length === 0) {
    isNoCard.value = true
    if (props.isShopcart) {
      // 购物车余额充值直接唤起弹窗
      openModal()
      return
    }
    fn && fn()
    return
  }
  // 不允许充值 0
  if ((!payPrice.value && !paypalAmount.value) && props.type === 'recharge') {
    isNoPrice.value = true
    return
  }
  // 充值选中卡片
  activeCard.value = cardList.value.filter((i: any) => { return i.active })[0] || {}
  if (!activeCard.value.creditCardId) {
    ElMessage.warning(t('请选择信用卡'))
    fn && fn()
    return
  }
  paypalTimeoutVisible.value = false
  let api = props.type === 'recharge' ? createPaypalWalletApi : createVipPaypalCreditCardApi
  // 信用卡0元支付特殊接口
  if (isZeroPay.value) {
    api = membershipOrderCreateCreditFree
  }
  const params = props.type === 'recharge' ? {
    originRechargeAmount: payPrice.value || paypalAmount.value,
    creditCardId: activeCard.value.creditCardId,
    customerId: store.getters.user?.customerId,
    originCurrencyCode: 'JPY',
    rechargeCurrencyCode: isMultiStore() ? currencyCode.value : undefined,
    allIncludeFlag: props.isShopcart
  } : {
    ...props.membershipParams,
    creditCardId: activeCard.value.creditCardId
  }
  paypalModalStatus.value = 'loading'
  submitLoading.value = true
  api(params).then((res: any) => {
    if (props.type === 'recharge') {
      // 充值余额
      walletPaypalCardCaptureApi({
        authorizationId: res.data.authorizationId,
        needValid: '',
        payPalOrderId: res.data.payPalOrderId,
        creditPaymentOption: true,
        rechargeCurrencyCode: currencyCode.value
      }).then((res: any) => {
        if (res.success) {
          paypalModalStatus.value = 'success'
          setTimeout(() => {
            paypalModalStatus.value = ''
            payPrice.value = ''
            // ElMessage.success(t('支付成功'))
            emit('success')
          }, 2000)
        }
      }).finally(() => {
        submitLoading.value = false
      })
      return
    }
    const paySuccess = () => {
      paypalModalStatus.value = 'success'
      setTimeout(() => {
        paypalModalStatus.value = ''
        payPrice.value = ''
        // 会员重置成功，清除成本计算器信息
        console.log('clear Calculator_plugin membership')
        window.localStorage.removeItem('Calculator_1_plugin')
        window.localStorage.removeItem('Calculator_2_plugin')
        // ElMessage.success(t('支付成功'))
        emit('success')
      }, 1000)
    }

    if (!isZeroPay.value) {
      // 充值会员
      membershipPaypalCaptureApi({
        ...props.membershipParams,
        authorizationId: res.data.authorizationId,
        creditCardOrderId: res.data.orderId
      }).then((res: any) => {
        if (res.success) {
          paySuccess()
        }
      }).finally(() => {
        fn()
        submitLoading.value = false
      })
    } else {
      paySuccess()
    }
  }).catch(() => {
    fn && fn()
    paypalModalStatus.value = ''
    submitLoading.value = false
    paypalTimeoutVisible.value = true
  })
}
const openModal = () => {
  creditCardPayVisible.value = true
}
getCardList()
// 输入卡信息支付回调
const submitPay = () => {
  paypalModalStatus.value = 'success'
  setTimeout(() => {
    paypalModalStatus.value = ''
    payPrice.value = ''
    creditCardPayVisible.value = false;
    getCardList();
    // ElMessage.success(t('支付成功'))
    emit('success')
  }, 2000)
}

// 删除卡
const del = (item: any) => {
  ElMessageBox.confirm(t('是否删除信用卡？'), t('提示'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消'),
    type: 'warning'
  })
    .then(() => {
      deleteCreditCardApi({
        creditCardId: item.creditCardId
      }).then(() => {
        // ElMessage.success(t('操作成功'))
        getCardList()
      })
    })
    .catch()
}

// 切换默认卡
const checkDefault = (item: any) => {
  changeCreditCardDefaultStatusApi({
    creditCardId: item.creditCardId
  }).then(() => {
    ElMessage.success(t('操作成功'))
    getCardList()
  })
}

const checkActive = (item: any) => {
  cardList.value = cardList.value.map((i: any) => {
    return {
      ...i,
      active: item.creditCardId === i.creditCardId
    }
  })
}
const ratePrice: any = computed(() => {
  const num = Number(payPrice.value)
  //   如果该账号支持韩元钱包，且用韩元钱包充值
  const floatingRateVal = isCurrencyCodeKRW.value ? floatingRateKrw.value : floatingRate.value
  let value = Math.floor(num * (1 - 0.034) / (Number(floatingRateVal)) * 100) / 100

  //   韩元取整，舍弃小数
  if (isCurrencyCodeKRW.value) {
    value = parseInt(String(value))
  }
  return value
})

expose({
  submit
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(' credit-card-pay ' + (props.type === 'recharge' ? 'credit-card-pay-recharge' : 'credit-card-pay-vip') + (__props.isShopcart ? ' credit-card-pay-shopcart' : ''))
  }, [
    (!__props.isShopcart)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_el_tooltip, {
              effect: "light",
              placement: "top-start",
              offset: 12,
              "popper-class": "credit-card-pay-tool"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型')), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            (__props.type !== 'vip')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('Paypal入金后，如果返金情况，手续费扣除不能返还')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "card-item empty",
              onClick: openModal
            }, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('绑定信用卡支付')), 1),
              (isNoCard.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('你还没有绑定信用卡')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{ active: item.active }, 'card-item']),
                key: index,
                onClick: ($event: any) => (checkActive(item))
              }, [
                _createElementVNode("div", _hoisted_12, "************" + _toDisplayString(item.lastDigits), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('有効期限')) + " " + _toDisplayString(item.expiry), 1),
                _createElementVNode("div", _hoisted_14, [
                  (item.isDefault !== 1)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "iconfont icon-moren1",
                        onClick: _withModifiers(($event: any) => (checkDefault(item)), ["stop"])
                      }, null, 8, _hoisted_15))
                    : _createCommentVNode("", true),
                  (item.isDefault === 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: _normalizeClass([{ active: item.isDefault === 1 }, 'tip'])
                  }, _toDisplayString(_unref(t)('设为默认支付方式2')), 3),
                  _createElementVNode("span", {
                    class: "iconfont icon-shanchu",
                    onClick: _withModifiers(($event: any) => (del(item)), ["stop"])
                  }, null, 8, _hoisted_17)
                ]),
                _hoisted_18
              ], 10, _hoisted_11))
            }), 128))
          ]),
          (props.type !== 'vip')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createTextVNode(_toDisplayString(_unref(t)('振込金額(日本円)')), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_input, {
                    modelValue: payPrice.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payPrice).value = $event)),
                    onInput: inputPrice
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_23, _toDisplayString((_unref(isCurrencyCodeKRW) ? _unref(t)('预计到账KRW：X韩元') :
            _unref(t)('预计到账CNY：X元')).replace('X', _unref(ratePrice))), 1)
                ]),
                (isNoPrice.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      _createTextVNode(_toDisplayString(_unref(t)('汇款金额必须大于0')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (__props.isShopcart)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_el_scrollbar, {
              height: "200px",
              always: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([{ active: item.active }, 'card-item']),
                      key: index,
                      onClick: ($event: any) => (checkActive(item))
                    }, [
                      _createElementVNode("div", _hoisted_29, "************" + _toDisplayString(item.lastDigits), 1),
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('有効期限')) + " " + _toDisplayString(item.expiry), 1),
                      _createElementVNode("div", _hoisted_31, [
                        (item.isDefault !== 1)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "no_check",
                              onClick: _withModifiers(($event: any) => (checkDefault(item)), ["stop"])
                            }, null, 8, _hoisted_32))
                          : _createCommentVNode("", true),
                        (item.isDefault === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          class: _normalizeClass([{ active: item.isDefault === 1 }, 'tip'])
                        }, _toDisplayString(_unref(t)('设为默认支付方式2')), 3),
                        _createElementVNode("img", {
                          src: "https://static-s.theckb.com/BusinessMarket/Client/choice/del_icon.png",
                          alt: "",
                          onClick: _withModifiers(($event: any) => (del(item)), ["stop"]),
                          class: "del-icon cursor-pt"
                        }, null, 8, _hoisted_34)
                      ]),
                      (item.active)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_28))
                  }), 128)),
                  _createElementVNode("div", {
                    class: "card-item empty",
                    onClick: openModal
                  }, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('绑定信用卡支付')), 1),
                    _hoisted_38
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)('余额可支付JPYX，剩余需支付:').replace('X', _unref(formatMoney)(__props.remainingPrice.shopWalletJPY))), 1),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("span", _hoisted_44, "JPY" + _toDisplayString(_unref(formatMoney)(__props.remainingPrice.jpy)), 1),
                  _createElementVNode("span", _hoisted_45, "CNY" + _toDisplayString(_unref(formatMoney)(__props.remainingPrice.cny)), 1)
                ]),
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('另需paypal手续费（由paypal收取）')) + ":JPY" + _toDisplayString(_unref(formatMoney)(_unref(serveFee))), 1)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", {
                  class: "pay-btn cursor-pt",
                  onClick: submit
                }, _toDisplayString(_unref(t)('去支付')), 1)
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (creditCardPayVisible.value)
      ? (_openBlock(), _createBlock(CreditCardPayDialog, {
          key: 2,
          currencyCode: _unref(currencyCode),
          visible: creditCardPayVisible.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((creditCardPayVisible).value = $event)),
          onSubmit: submitPay,
          type: props.type,
          membershipParams: props.membershipParams,
          paypalAmount: _unref(paypalAmount)
        }, null, 8, ["currencyCode", "visible", "type", "membershipParams", "paypalAmount"]))
      : _createCommentVNode("", true),
    _createVNode(PaypalPayModal, { type: paypalModalStatus.value }, null, 8, ["type"]),
    _createVNode(PaypalTimeout, {
      visible: paypalTimeoutVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((paypalTimeoutVisible).value = $event)),
      onSubmit: submit
    }, null, 8, ["visible"])
  ], 2))
}
}

})